
<template>
    <div class='main-wrapper'>

        <div class="flex column space-between align-start section-top">
            <div class="requirements">

                <h3 class="doc-header mb-0">List of Required Documents for KYC & Due Diligence</h3>
                <p>1. Due Diligence Form – dated and signed by the company representative <span class='file-label' :class="docstatus('due_dil_form', true)"> {{ docstatus('due_dil_form') }}</span></p>
                <p>2. Certified true copy of Certificate of Incorporation<span class='file-label' :class="docstatus('certofinc', true)"> {{ docstatus('certofinc') }}</span> </p>
                <p>3. Articles of Incorporation/Memorandum of Incorporation or similar document<span class='file-label' :class="docstatus('article_if_incorp', true)"> {{ docstatus('article_if_incorp') }}</span></p>
                <p>4. Certified Excerpt from the Register (dated & signed, not older than 6 months)<span class='file-label' :class="docstatus('cert_excerpt_from_register', true)"> {{ docstatus('cert_excerpt_from_register') }}</span></p>


                <p>5. Register of Shareholders (signed & dated, not older than 6 months)<span class='file-label' :class="docstatus('register_of_shareholders', true)"> {{ docstatus('register_of_shareholders') }}</span></p>
                <p>6. Director's Register (signed & dated, not older than 6 months)<span class='file-label' :class="docstatus('director_register', true)"> {{ docstatus('director_register') }}</span></p>
                <p>7. Certified true copy of a valid document confirming company representative authority (if applicable)<span class='file-label' :class="docstatus('cert_copy_of_representative', true)"> {{ docstatus('cert_copy_of_representative') }}</span></p>

                <p>8. Recent Structure Chart up to UBOs holding ≥25% (signed & dated)<span class='file-label' :class="docstatus('structure_chart', true)"> {{ docstatus('structure_chart') }}</span></p>
                <p>9. Proof of domain ownership<span class='file-label' :class="docstatus('proof_of_domain_ownership', true)"> {{ docstatus('proof_of_domain_ownership') }}</span></p>
                <p>10. Copies of valid licenses/permits/certificates and registrations held by the company<span class='file-label' :class="docstatus('copy_of_license', true)"> {{ docstatus('copy_of_license') }}</span></p>
                <p>11. AML/CFT/Responsible gaming/KYC/Privacy policies (signed & dated, not older than 12 months)<span class='file-label' :class="docstatus('privacy_policy', true)"> {{ docstatus('privacy_policy') }}</span></p>

                <h4 class="text-left">For <em>each</em> Director, Shareholder, and UBO holding ≥25%</h4>
                <p>12. Certified true copy of passport (not older than 6 months)</p>
                <p>13. Proof of address – utility bill/bank statement (signed & dated)</p>
            </div>
            <div>
                <p class="text-left"><strong>As part of the KYC and DD procedures, all the documents shall be provided in English. If the original language of the provided documents is different from English, the documents shall be translated to English and certified by a qualified attorney, qualified accountant or other warranted professional.</strong></p>
            </div>
            <div class="button w-full" v-if="(dueDiligenceRecord?.status !== 'approved' && !store.state.user)">
                <button @click='showUpload()' class="w-content left-auto">Upload document</button>
            </div>
            <div class="w-full mt-20" style="overflow-x: auto;">
                <div>
                    <table class="bold">
                            <tr class="grayish">
                                <th>File Name</th>
                                <th>Document Type</th>
                                <th>Comment</th>
                                <th>Size</th>
                                <th>Date Added</th>
                                <th>Review Status</th>
                                <th></th>
                                <th></th>
                            </tr>
                      
                            <tr v-for="row of kyc_files" class="file-row" @click="openFile(row)">
                                <td class="primaty-color">
                                    {{ row?.file?.filename }}

                                    <span v-if="row.dueDiligenceElement">

                                    </span>
                                </td>
                                <td>
                                {{ dueDiligenceDocumentType(row?.documentType) }} 
                                <span v-if="row.dueDiligenceElement"> <br>
                                        (for {{ getDueDiligenceElementName(row?.dueDiligenceElement) }})

                                </span>
                                </td>
                                <td class="comment-section-due-diligence">
                                    <div v-if="row?.client_comment" :innerHTML="row?.client_comment" class="document-comments"></div>
                                    <div v-else> - </div>
                                </td>
                                <td>
                                    {{ Utils.calculateFileSize(row?.file?.filesize) }}
                                </td>
                                <td>
                                    {{ referanceDate(row?.file?.uploadDate) }}
                                </td>
                                <td>
                                    <div class="file-status" :class="row.status">
                                        {{ statusMap(row.status) }}
                                    </div>
                                </td>
                                <td class="pointer" @click="(event) => { event.stopPropagation(); downloadFile(row) }">

                                    <img src="@/assets/download.svg" class="download-icon"/>
                                </td>
                                <td v-if="!disabled"class="pointer" @click="() => deleteConfirm = row">
                                    <img src="@/assets/delete.svg" class="cross-icon"/>
                                </td>
                                <td v-else></td>
                            </tr>
                    </table>
                </div>
            </div>
        </div>
        
        <PopupCover v-if="addDoc" @close="addDoc = false">
            <DueDiligenceUploadDocPopup
                @close="addDoc = null"
            />
        </PopupCover>
        <PopupCover v-if="deleteConfirm" @close="() => deleteConfirm = !deleteConfirm">
            <ConfirmationPopup 
                @confirm="deleteFile"
                @cancel="() => deleteConfirm = !deleteConfirm"
                :title="`Delete Document`"
                :message="`Are you sure you want to delete this ${dueDiligenceDocumentType(deleteConfirm.documentType)}?`"
            />
        </PopupCover>


        <PopupCover v-if="fileDetailes" @close="fileDetailes = false">
            <PopupBody
                class="message-details"
                @close="fileDetailes = null"
            >
                <template #header>
                    <h3 class="popup-header flex gap-20 align-center">File Details
                        <div class="file-status w-content" :class="fileDetailes.status">
                            {{ statusMap(fileDetailes.status) }}
                        </div>
                    </h3>
                </template>
                <template #body>
                    <div class="popup-content gap-10 flex column">
                        
                        <div class="message">
                            <div class="message-header ">
                                <div class="message-author">{{ dueDiligenceDocumentType(fileDetailes?.documentType) }} 
                                    
                                </div>
                            </div>
                            <div class="message-attachments">
                                <div class='attachment'>
                                    <img src="@/assets/file.svg" class='fileicon'>
                                    <div class="filename">
                                        <div class="name-of-the-file">{{ fileDetailes?.file?.filename }}</div>
                                        <div class="size-of-the-file">{{ Utils.calculateFileSize(fileDetailes?.file?.filesize) }}</div>
                                    </div>
                                    <div class="flex column space-between gap-10 margin-left-auto">
                                        <div class="message-date">{{ dayjs(fileDetailes.uploadDate).format('MMM DD, YYYY hh:mm A') }}</div>
                                        <img src="@/assets/download.svg" class='download' @click="downloadFile(fileDetailes)">
                                    </div>
                                </div>
                            </div>
                            <div class="text-left comment-response">
                                Client Comment:
                                <div class="message-content" v-html="fileDetailes.client_comment"></div>
                            </div>
                            <div class="text-left comment-response" v-if="fileDetailes.admin_comment">
                                Response:
                                <div class="message-content" v-html="fileDetailes.admin_comment"></div>
                            </div>
                         
                        </div>
                        <div v-if="commentShown">
                            <CommentSection @changeinput="quillContent" class="markdown-content" :placeholder="`${fileDetailes.status == 'rejected' ? 'Add Rejection Reason (Will override existing one)' : 'Rejection Reason'}`"/>
                        </div>
                        <div class="buttons flex row gap-10" v-if="store.state.user && fileDetailes.status != 'approved'">
                            <div class="margin-left-auto"></div>
                            <button v-if="commentShown" class="button w-content transparent" @click="() => commentShown = false">
                                Cancel
                            </button>
                            <button class="button w-content" @click="() => handleStateChange('rejected')">
                                Reject
                            </button>
                            <button v-if="!commentShown" class="button w-content" @click="() => handleStateChange('approved')">
                                Accept
                            </button>

                        </div>
                    </div>
                </template>
            </PopupBody>
        </PopupCover>


        



        <div class="save-area" v-if="needToSave">
            <div class="save-area-inner">
                <button class="add-new fit-content no-margin" v-if="!savingData" @click="Save()"> Save </button>
                <button class="add-new fit-content no-margin" v-else disabled> Saving.. </button>
            </div>
        </div>
    </div>
 
</template>
<script setup>
import { ref, computed, defineEmits, onMounted, defineProps } from 'vue'
import TableFileRow2 from '@/components/TableFileRow2.vue'
import TableHeaderRow from '@/components/TableHeaderRow.vue'
import { PermissionChecker } from '@/utils/iam_utils';
import Subsidiaries from '@/components/Subsidiaries.vue';
import store from '@/store/index.js';
import API from '@/api/index.js';
import { useRoute } from 'vue-router';
import PopupCover from '@/components/PopupCover.vue';
import DueDiligenceUploadDocPopup from '@/components/DueDiligenceUploadDocPopup.vue';
import Utils from '@/utils/index.js';
import dayjs from 'dayjs';
import CommentSection from './CommentSection.vue';
import { DUE_DILIGENCE_DOC_TYPES, dueDiligenceDocumentType } from '@/utils/kyc_utils.js';

import { new_comments } from '@/utils/kyc_utils.js'

import ConfirmationPopup from '@/components/ConfirmationPopup.vue';
import PopupBody from '@/components/PopupBody.vue';

const route = useRoute();
const disabled = computed(() => store.state.dueDiligenceRecord.status != 'draft' || store.state.user ) ;

const props = defineProps(['id']);
const queryParams = computed( () => route.query )
const dueDiligenceElements = computed(() => store.state.dueDiligenceElements);
const savingData = ref(false);
const addDoc = ref(false);
const dueDiligenceRecord = computed(() => store.state.dueDiligenceRecord);
const viewingToken = ref(queryParams.value.token)

const kyc_files = computed( () => {
    return store.state.kyc_files.filter( el => !!el.dueDiligence && el.file)
})


const fileDetailes = ref(null);
const needToSave = computed(() => store.getters.needToSave)

const deleteConfirm = ref(null);

const commentShown = ref(false);
const rejectReason = ref(null);


const getFileId = (type) => {
    return computed(() => store.getters.getFileId(type));
}



function docstatus(doc_type, raw = false) {
    
    const file = kyc_files.value.find( el => el.documentType == doc_type);
    console.log('file', file)
    if (file) {
        return raw ? file.status : statusMap(file.status);
    }
    return raw ? 'not_uploaded' : 'Not uploaded';

}

function openFile(file){
    fileDetailes.value = file;
}


function quillContent(event) {
    rejectReason.value = event.text
}

const referanceDate = (dateString) => {
    const now = dayjs();
    const date = dayjs(dateString);
    const diffInSeconds = now.diff(date, 'second');
    const diffInMinutes = now.diff(date, 'minute');
    const diffInHours = now.diff(date, 'hour');
    const diffInDays = now.diff(date, 'day');

    if (diffInSeconds < 60) {
        return `${diffInSeconds} seconds ago`;
    } else if (diffInMinutes < 60) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? 's' : ''} ago`;
    } else if (diffInHours < 24) {
        return `${diffInHours} hour${diffInHours > 1 ? 's' : ''} ago`;
    } else if (diffInDays <= 30) {
        return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    } else {
        return date.format('YYYY-MM-DD');
    }
};

const statusMap = (status) => {
    const statusMap = {
        'pending': 'Pending Review',
        'approved': 'Approved',
        'rejected': 'Rejected',
    }
    return statusMap[status] || status;
}


async function downloadFile(file){
    await API.DownloadKYCFile(file.file.serverName, file.file.filename, viewingToken.value);
}
function getDueDiligenceElementName(element){
    const elementData = dueDiligenceElements.value.find( el => el._id === element);
    if (elementData) {
        return elementData.company_name?.new_value || elementData.company_name?.value || elementData.full_name?.new_value || elementData.full_name?.value;
    }
    return '';
}



async function handleStateChange(state){
    if (state == 'rejected' && !commentShown.value) {
        commentShown.value = true;
        return;
    }
    if (state == 'rejected' && !rejectReason.value) {
        store.dispatch('addNotification', {
            text: 'Please add a rejection explanation',
            type: 'error'
        });
        return
    }
    let value = rejectReason?.value;
    if (state == 'rejected' && (!value || value.trim() == '')) {
        store.dispatch('addNotification', {
            text: 'Please add a rejection explanation',
            type: 'error'
        });
        return;
    }
    const result = await API.changeDocumentState(
        { 
            id: fileDetailes.value.id, 
            status: state, 
            comment: rejectReason.value
        }
    );
    if (result.status == 'success'){
        store.state.kyc_files = store.state.kyc_files.map( el => {
            if (el.id == fileDetailes.value.id) {

                el.status = state;
                el.admin_comment = rejectReason.value;

                store.dispatch('addNotification', {
                    text: `Document status changed to ${state}`,
                    type: 'success'
                });
            }
            return el;
        });
        fileDetailes.value = null;
    } else {
        store.dispatch('addNotification', {
            text: 'Error while changing document state',
            type: 'error'
        });
    }

}
async function deleteFile(event){
    event.stopPropagation();
    event.preventDefault();

    if (disabled.value) {
        return;
    }
    const result = await API.deleteObject(deleteConfirm.value.id, 'kyc_file', deleteConfirm.value.file.filename + 'file');
    store.state.kyc_files = store.state.kyc_files.filter( el => el.id !== deleteConfirm.value.id);
    deleteConfirm.value = null;
}

onMounted(async () => {

});




function showUpload(){
    addDoc.value = true;
}


</script>

<style scoped lang="scss">
    .main-wrapper {
        max-width: 1350px;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        border-radius: 10px;   
    }
    .file-label {
        font-weight: 600;
        color: var(--primary-color);
        font-size: 14px;
        margin-left: 10px;
        color: white;
        padding: 2px 5px;

        border-radius: 5px;
        &.not_uploaded {
            background-color: rgba(128, 128, 128, 0.5);
        }
        &.pending {
            background-color: rgba(48, 48, 48, 0.5);
        }
        &.approved {
            background-color: #008000;
        }
        &.rejected {
            background-color: #FF0000;
        }

    }
    .header-of-section {
        justify-content: space-between;
        align-items: center;
        width: 100%;
        button {
            margin-top: 0;
        }
        h3 {
            color: black;
        }   
    }
    .content {
        max-height: 0;
        overflow-y: hidden;
        transition: max-height 0.3s ease-in-out, padding 0.3s ease-in-out;
    }
    .header-section {
        padding-left: 20px;
        background-color: white;
        height: 125px;
        display: flex;
        padding-left: 35px;
        align-items: center;
        justify-content: center;
    }
    
    .kyc-header {
        max-width: 1350px;
        width: 100%;
        text-align: left;
        font-size: 28px;
        position: relative;

        .tab-views {
            font-size: 14px;
            position: absolute;
            left: 0;
            top: 40px;
            display: flex;
            .tab {
                padding: 10px 20px;
                cursor: pointer;
                &.active {
                    background-color: #f5f5f5;
                }
            }
        }
    }
    .file-row {
        cursor: pointer;
        &:hover {
            background-color: rgb(0 115 239 / 4%);
        }
    }
    .grayish {
        background-color: #F6F6FC ;
    }
    .kyc-fields-container {
        width: 100%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
    .comment-section-due-diligence {

        &:deep(p) {
            margin: 0;
            padding: 0;
            font-size: 14px;
            color: #000;
            font-weight: 400;
        }
    }
    .markdown-content {
        height: 200px;
    }
    .comment-response {
        padding: 10px;
        border: 1px solid var(--border-color);
        background: white;
        border-radius: 10px;
    }
    th {
        padding: 10px;
        border: 1px solid var(--border-color);
    }
    .kyc-fields-area {
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        border-top: unset;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
    h3 {
        margin: 0px;
        margin-bottom: 4px;
    }
    .file-status {
        padding: 5px 10px;
        border-radius: 5px;
        font-size: 14px;
        font-weight: 600;
        color: white;
        line-height: normal;
        &.pending {
            background-color: rgba(128, 128, 128, 0.5);
        }
        &.approved {
            background-color: #008000;
        }
        &.rejected {
            background-color: #FF0000;
        }
    }
    .kyc-item-section {
        position: relative;
        width: 100%;
        margin-top: 15px;
        h3 {
            position: absolute;
            background: var(--app-background);
            border-radius: 5px;
            border: 1px solid var(--border-color);
            padding: 0 5px;
            left: -1.5px;
            border-bottom-left-radius: 0;
            color: #000;
            font-weight: 600;
            text-align: left;
            max-width: 86%;
            top: -12px;
            left: 0px;
            font-size: 14px;
            z-index: 2;
            text-align: left;
        }
        &.extra-margin {
            margin-bottom: 50px;
        }
    }
    .flex {
        display: flex;
        &.row {
            flex-direction: row;
        }
        &.column {
            flex-direction: column;
        }
    }
    .passport-fields {
        margin-top: 20px;
    }
    .gap30 {
        gap: 30px;
    }
    .black {
        color: black;
    }
    textarea {
        resize: none; 
        box-sizing: border-box;
        font-family: Avenir, Helvetica, Arial, sans-serif;
        padding: 15px;
        border-radius: 10px;
        height: 150px;

        &:focus {
            outline: none;
            border: 1px solid var(--primary-color);
        }
    }
    .data-holder-comment {
        height: 120px;
        width: 500px;
    }
    .document-comments {
        vertical-align: bottom;
        
    }
    .add-new {
        margin-left: auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .margin-top-20 {
        margin-top: 20px;
    }
    .margin-top-negative {
        margin-top: -40px;
        margin-bottom: 5px;
    }
    .limited-width {
        
    }

.requirements {
    p {
        text-align: left;
        margin: 0;
        padding-left: 10px;
    }
}
table {
    border-collapse: collapse;
    width: 100%;
}

thead {
    font-weight: bold;
}
td {
    padding: 10px;
    border: 1px solid var(--border-color);
}

.no-border > td {
    border: none;
}
.margin-20 {
    height: 20px;
}
.save-area {

position: fixed;
bottom: 0px;
display: flex;
justify-content: center;
align-items: center;

width: 100%;
z-index: 1000;

}
.save-area-inner {
position: relative;
left: 20px;
max-width: 1050px;
width: 100%;
box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
box-sizing: border-box;
display: flex;
justify-content: center;
background: white;
border: 1px solid var(--border-color);
border-top-left-radius: 5px;
border-top-right-radius: 5px;
justify-content: flex-start;
align-items: center;
padding: 5px;
button {
    height: 35px;
    margin-left: unset;
    margin: 0;
}
}
.left-auto {
    margin-left: auto;
}

.message-details.container {
    width: 500px;
}

.download {
    margin-left: auto;
    cursor: pointer;
    width: 15px;
    height: 15px;
}

.filename {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}
.message-attachments {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: rgb(246, 246, 252);
}

.size-of-the-file {
    font-size: 0.8rem;
    color: rgb(116 119 127);
}
.name-of-the-file {
    display: flex;
    align-items: center;
    color: black;
    font-size: 0.9rem;
    max-width: 250px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fileicon {
    width: 40px;
    height: 40px;
}

.attachment {
    border-radius: .5rem;
    border-width: 1px;
    -moz-column-gap: .5rem;
    column-gap: .5rem;
    grid-template-columns: fit-content(100%) 1fr;
    border-color: rgb(224 226 236);
    background-color: rgb(255 255 255);
    padding: .8rem;


    display: flex;
    align-items: center;
}

.message-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
    padding: 1rem 1.5rem;
}
.message-content {
    font-size: 0.9rem;
    line-height: 1.5rem;
    color: rgb(24 28 34);
    text-align: left;
    &:deep(p) {
        margin: 0;
    }
    
}
.status-select {
    margin-top: 5px;
    width: fit-content;
}

.message-author {
    text-align: left;
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: nowrap;
    word-break: break-word;
    color: black;
}
.message-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.message-date {
    color: rgb(91 94 102);
    background: rgb(224 226 236);
    border-radius: .125rem;
    height: 1rem;
    text-wrap: nowrap;
    width: fit-content;
    font-size: .75rem;
    font-weight: 700;
    line-height: 1rem;
    padding: .125rem;
}
.message {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-radius: 10px;
    background-color: rgb(246 246 252);
    border: 1px solid var(--border-color);
    padding: .75rem;
}

</style>
